/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Purchase_DescInputs */

const en_consult_purchase_desc = /** @type {(inputs: Consult_Purchase_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No payment is taken here. Send the request and we reply by email with a proposal.`)
};

const id_consult_purchase_desc = /** @type {(inputs: Consult_Purchase_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada pembayaran di sini. Kirim permintaan, kami balas lewat email dengan proposal.`)
};

/**
* | output |
* | --- |
* | "No payment is taken here. Send the request and we reply by email with a proposal." |
*
* @param {Consult_Purchase_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_purchase_desc = /** @type {((inputs?: Consult_Purchase_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Purchase_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_purchase_desc(inputs)
	return en_consult_purchase_desc(inputs)
});